import React, { useEffect } from 'react'
import useUser from '../../hooks/useUser';

const UserExistsExpress = () => {
    const [dataUser,setDataUser,_,__,initialDataUser]= useUser();
    useEffect(() => {
      setTimeout(() => {
        console.log('Usuario Ya existe en Aptos y Vtex:..');
        setDataUser(initialDataUser);
      },10000);
    }, [])
    
  return (
    <div>
        <h2 className="ms-auto me-auto p-2 text-danger fs-6 mt-3 text-center pb-3 border rounded bg-secondary bg-opacity-10 w-75">
        El correo ingresado ya se encuentra registrado en MINISOLOVE. Gracias
        </h2>
    </div>
  )
}

export default UserExistsExpress

